<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <h4 class="font-weight-bold text-primary">Dashboard Financeiro</h4>
        <div class="row">
            <div class="col-xl-7 col-md-7 col-sm-12 mb-4">
                <div class="card">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Até o momento</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-6 col-md-6 col-sm-12">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="card shadow h-100 py-2 border-left-success ">
                                            <div class="card-body">
                                                <div class="row no-gutters align-items-center mb-0">
                                                    <i class="fas fa-2x fa-arrow-up green mt-0"></i>
                                                    <div class="col ml-3">
                                                        <div class="text-xs text-primary text-uppercase mb-0">
                                                            <h5 class="font-weight-bold green">Entrou <div
                                                                    class="h5 mb-0 font-weight-bold green right mt-3">{{
                                                                        sum_total_receivable_account_paid_formatted }}
                                                                </div>
                                                            </h5>Receitas
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="card shadow h-100 py-2 border-left-danger">
                                            <div class="card-body">
                                                <div class="row no-gutters align-items-center mb-0">
                                                    <i class="fas fa-2x fa-arrow-down red mt-0"></i>
                                                    <div class="col">
                                                        <div class="text-xs text-primary text-uppercase mb-0">
                                                            <h5 class="font-weight-bold red">Saiu <div
                                                                    class="h5 mb-0 font-weight-bold red right mt-3">{{
                                                                        sum_total_payable_account_paid_formatted }}</div>
                                                            </h5>Despesas
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="card shadow h-100 py-2 border-left-secondary">
                                            <div class="card-body">
                                                <div class="row no-gutters align-items-center mb-0">
                                                    <i class="fas fa-2x fa-arrow-right black mt-0"></i>
                                                    <div class="col ml-3">
                                                        <div class="text-xs text-primary text-uppercase mb-0">
                                                            <h5 class="font-weight-bold black">Sobrou <div
                                                                    class="h5 mb-0 font-weight-bold black right mt-1">{{
                                                                        total_financial_formatted }}</div>
                                                            </h5>Saldo
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-sm-12">
                                <GraphCircleResumeFinancial :data="data_pie_resume"></GraphCircleResumeFinancial>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-md-5 col-sm-12 mb-4">
                <div class="card">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Receita x Despesas durante o ano</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <GraphAnnualFinancial :year="year_annual_financial"></GraphAnnualFinancial>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-n3">
            <div class="col-xl-7 col-md-7 col-sm-12">
                <div class="card">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Dependentes e Atrasados</h6>
                    </div>
                    <div class="card-body">
                        <div class="row mb-0">
                            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
                                <div class="row">
                                    <div class="col-xl-6 col-md-6 col-sm-12 mb-4">
                                        <quantitativeData color="border-left-warning" nameCard="Receitas pendentes"
                                            :number="sum_total_receivable_account_pending_formatted"
                                            icon="fa-hourglass">
                                        </quantitativeData>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12 mb-4">
                                        <quantitativeData color="border-left-danger" nameCard="Receitas em atraso"
                                            :number="sum_total_receivable_account_overdue_formatted"
                                            icon="fa-exclamation">
                                        </quantitativeData>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-n4">
                            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
                                <div class="row">
                                    <div class="col-xl-6 col-md-6 col-sm-12 mb-4">
                                        <quantitativeData color="border-left-warning" nameCard="Despesas pendentes"
                                            :number="sum_total_payable_account_pending_formatted" icon="fa-hourglass">
                                        </quantitativeData>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12 mb-4">
                                        <quantitativeData color="border-left-danger" nameCard="Despesas em atraso"
                                            :number="sum_total_payable_account_overdue_formatted" icon="fa-exclamation">
                                        </quantitativeData>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-md-5 col-sm-12">
                <div class="card">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Top 3 maiores receitas</h6>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Cliente / Documento</th>

                                        <th class="text-center">Valor</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(receivable_account) in receivable_accounts"
                                        :key="receivable_account.id">
                                        <td class="align-middle">
                                            {{ receivable_account.client.name }}<br>
                                            {{ receivable_account.client.document_formatted }} - <span class="badge badge-success">{{ receivable_account.payment_date_formatted  }}</span>
                                        </td>

                                        <td class="text-center align-middle">{{
                                            receivable_account.amount_formatted }} </td>
                                    </tr>
                                    <tr v-show="receivable_accounts.length <= 0">
                                        <td colspan="4" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import GraphCircleResumeFinancial from './graph-circle-resume-financial.vue';
import quantitativeData from '@/components/dashboard/quantitative-data.vue'
import GraphAnnualFinancial from '@/components/dashboard/graph-annual-financial.vue'


export default {
    components: {
        Loading, GraphCircleResumeFinancial, quantitativeData, GraphAnnualFinancial
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            sum_total_receivable_account_paid_formatted: 'Carregando',
            sum_total_payable_account_paid_formatted: 'Carregando',
            total_financial_formatted: 'Carregando',
            sum_total_receivable_account_pending_formatted: 'Carregando',
            sum_total_payable_account_pending_formatted: 'Carregando',
            sum_total_receivable_account_overdue_formatted: 'Carregando',
            sum_total_payable_account_overdue_formatted: 'Carregando',
            total_receivable_account_pending: 'Carregando',
            total_payable_account_pending: 'Carregando',
            year_annual_financial: '2025',
            name_user: '',
            receivable_accounts: [],
            data_pie_resume: {
                labels: ['Receita', 'Despesa'],
                datasets: []
            },
        }
    },
    mounted() {
        this.name_user = localStorage.getItem('name');
        this.loadData();
    },
    methods: {
        onCancel() { },
        loadData() {
            console.clear();
            this.isLoading = true;
            api.get('/dashboard-financial/resume')
                .then((response) => {
                    this.isLoading = false;
                    this.sum_total_receivable_account_paid_formatted = response.data.data.sum_total_receivable_account_paid_formatted;
                    this.sum_total_payable_account_paid_formatted = response.data.data.sum_total_payable_account_paid_formatted;
                    this.total_financial_formatted = response.data.data.total_financial_formatted;
                    this.sum_total_receivable_account_pending_formatted = response.data.data.sum_total_receivable_account_pending_formatted;
                    this.sum_total_payable_account_pending_formatted = response.data.data.sum_total_payable_account_pending_formatted;
                    this.sum_total_receivable_account_overdue_formatted = response.data.data.sum_total_receivable_account_overdue_formatted;
                    this.sum_total_payable_account_overdue_formatted = response.data.data.sum_total_payable_account_overdue_formatted;
                    this.data_pie_resume.datasets =
                        [
                            {
                                'backgroundColor': ['rgba(1,97,38, 0.8)', 'rgba(128,3,3, 0.8)'],
                                'data': [response.data.data.sum_total_receivable_account_paid, response.data.data.sum_total_payable_account_paid]
                            }
                        ];
                    this.loadTopFiveReceivableAccount();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        loadTopFiveReceivableAccount() {
            api.get('/dashboard-financial/topFiveReceivable')
                .then((response) => {
                    this.receivable_accounts = response.data.receivable;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        }
    }
}
</script>

<style>
.right {
    float: right
}

.green {
    color: #079c07;
}

.red {
    color: #9c0000;
}

.black {
    color: #000000;
}

.select-graph {
    width: 25% !important;
    float: right;
}
</style>